export const en = {
    budget: 'Budget, {currency}',
    clicks: 'Clicks',
    'clicks-forecast': 'Estimated clicks',
    cost: 'Spending, {currency}',
    'cost-forecast': 'Estimated spending, {currency}',
    name: 'Campaign name',
    'recommended-budget': 'Recommended budget, {currency}',
    status: 'Status',
    type: 'Type'
};
